document.querySelector('#copyright').textContent = new Date()
    .getFullYear()
    .toString();
